import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = { class: "absolute" }
const _hoisted_5 = { class: "h-10 flex flex-col justify-center" }
const _hoisted_6 = { class: "absolute" }
const _hoisted_7 = { class: "h-10 flex items-center pl-2" }
const _hoisted_8 = ["onKeyup"]
const _hoisted_9 = { id: "suggestions" }
const _hoisted_10 = ["value"]

import { FilterIcon, XIcon } from '@heroicons/vue/solid';
import { PropType, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  highlightIcon: {
    type: Boolean,
    default: false,
  },
  suggestions: {
    type: Object as PropType<Set<string>>,
  },
},
  emits: ['submit'],
  setup(__props, { emit }) {





const text: Ref<string> = ref('');

const submit = async () => {
  if (text.value === '') {
    // empty filter, do nothing
  } else {
    emit('submit', text.value);
    text.value = '';
  }
};

const clear = async () => {
  text.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (text.value && text.value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "h-5 w-5 mr-2 cursor-pointer",
                  onClick: clear
                }, [
                  _createVNode(_unref(XIcon))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "w-5 h-5 cursor-pointer",
          onClick: submit
        }, [
          (__props.highlightIcon)
            ? (_openBlock(), _createBlock(_unref(FilterIcon), {
                key: 0,
                class: "text-secondary"
              }))
            : (_openBlock(), _createBlock(_unref(FilterIcon), {
                key: 1,
                class: "text-gray-300"
              }))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "border border-gray-300 rounded w-full h-10 px-10 focus:border-secondary focus:outline-none",
      type: "text",
      placeholder: "Filter by keyword, author, title, ...",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      onKeyup: _withKeys(submit, ["enter"]),
      list: "suggestions"
    }, null, 40, _hoisted_8), [
      [_vModelText, text.value]
    ]),
    _createElementVNode("datalist", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.suggestions, (suggestion, idx) => {
        return (_openBlock(), _createElementBlock("option", {
          key: idx,
          value: suggestion
        }, null, 8, _hoisted_10))
      }), 128))
    ])
  ]))
}
}

})